import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=1dec18b6"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dec18b6')) {
      api.createRecord('1dec18b6', component.options)
    } else {
      api.reload('1dec18b6', component.options)
    }
    module.hot.accept("./UserEdit.vue?vue&type=template&id=1dec18b6", function () {
      api.rerender('1dec18b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/users/UserEdit.vue"
export default component.exports